export default function inDeleteMediaView({ state, path }) {
  const inView =
    state.get('app.currentView') === 'media' && !state.get('media.showDetail')

  return inView ? path.true() : path.false()
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/inDeleteMediaView.js